import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NbStepperComponent, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { SetupService } from '@core/services/setup';
import { AuthService } from '../../auth.service';

@Component({
    selector: 'app-request-password',
    templateUrl: './request-password.component.html',
    styleUrls: ['./request-password.component.scss'],
})
export class RequestPasswordComponent implements OnInit {
    /* Alerta de erro e sucesso */
    alert = {
        show: false,
        message: '',
        type: 'success',
    };

    form: FormGroup;
    formSendCode: FormGroup;
    formValidateCode: FormGroup;
    selectedMethod;
    recoveryMethods$ = this.authService.getPassRecoveryMethods();

    usersFound: any;

    player: string;
    typeSending: string;
    codeToken: string;

    @ViewChild('stepper') stepper: NbStepperComponent;

    maskConfig = {
        '1': '',
        '2': '000.000.000.00',
        '3': '(00) 0 0000-0000',
    };

    get controls() {
        return this.form.controls;
    }

    get mask() {
        if (!this.selectedMethod) return '';

        if (this.selectedMethod.id === '2' && this.selectedMethod.label === 'CPF') {
            return this.maskConfig[this.selectedMethod.id];
        } else if (this.selectedMethod === '2') {
            return '';
        }

        return this.maskConfig[this.selectedMethod.id];
    }

    constructor(
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private title: Title,
        private setupService: SetupService,
        private toastrService: NbToastrService,
        private translate: TranslateService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            recovery_method: ['', Validators.required],
        });

        this.formSendCode = new FormGroup({
            type_sending: new FormControl(null, Validators.required),
            player: new FormControl('', Validators.required),
        });

        this.formValidateCode = new FormGroup({
            player: new FormControl(),
            code: new FormControl(),
            code_token: new FormControl(),
        });

        this.title.setTitle(`Recuperar Senha - ${this.setupService.title}`);
    }

    onRequestFind() {
        this.authService
            .passRecoveryFind({
                id: this.selectedMethod.id,
                ...this.form.value,
            })
            .subscribe((response) => {
                if (response.statusCode === 1)
                    return this.toastrService.danger(
                        this.translate.instant('ALERT.ERROR.DESCRIPTION'),
                        this.translate.instant('ALERT.ERROR.TITLE')
                    );
                this.usersFound = response.registers;
                this.stepper.next();
            });
    }

    onUserSelect(user) {
        this.player = user.id_site;
        this.formValidateCode.patchValue({
            player: user.id_site,
        });
    }

    onTokenSent({ code, type_sending }) {
        this.typeSending = type_sending;
        this.codeToken = code;
        this.stepper.next();
        this.toastrService.success(
            this.translate.instant('ALERT.SUCCESS.DESCRIPTION'),
            this.translate.instant('ALERT.SUCCESS.TITLE')
        );
    }

    onMethodChange() {
        this.form.reset();
    }

    onValidationSuccess() {
        this.toastrService.success(
            this.translate.instant('ALERT.SUCCESS.TITLE'),
            this.translate.instant('ALERT.SUCCESS.DESCRIPTION')
        );
        this.router.navigate(['/auth/change-password'], {
            queryParams: { player: this.player, token: this.codeToken },
        });
    }

    requestPassword() {
        this.authService.requestPassword(this.form.value).subscribe(
            (returnSuccess) => this.successCallbackApi(returnSuccess),
            (returnFail) => this.errorCallbackServer(returnFail)
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    async successCallbackApi(response: any) {
        const success = response.status_code === 0;
        this.alert.message = response.description;
        this.alert.type = success ? 'success' : 'danger';
        this.alert.show = true;

        if (success) {
            this.controls.email.reset();
        }
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        // TODO:
        // - EXIBIR ALERTA ERRO
        // - LIMPAR CAMPO SENHA
        this.alert.type = 'danger';
    }
}
